import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 10000
})
client.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})
client.interceptors.response.use(response => {
  const body = response.data
  if (body.code !== 0) return Promise.reject(new Error(body.message || '请求失败'))
  return body.data
}, error => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('admin_token')
    if (window.location.hash !== '#/login') window.location.hash = '#/login'
  }
  return Promise.reject(new Error(
    (error.response && error.response.data && error.response.data.message) ||
    error.message || '网络请求失败'
  ))
})
export default client
